import { GlobalState } from '../../../types.global';

// -----------------------------------------------------------------------------
// SELECTORS

import { toDayFormat } from '../../../../shared';
import { GoogleAccount, UserDb } from './types';
import { selectUiMode } from '../../../store/selectors';
import { selectAdTiles } from '../../tiles/slice';
// import { setTopSitesViewed } from './reducer';
import { getDaysOfUsage } from '../../story/slice/utils';

export const shellsToBottles = (shells: number): number =>
  Math.floor(shells / 100);

export const selectInstallationDate = ({ user }: GlobalState): number =>
  user.installationDate;
export const selectUserId = ({ user }: GlobalState): string => user.userId;
export const selectNtpVisitCounter = ({ user }: GlobalState): number =>
  user.ntpVisitCounter;
export const selectIsNewBottles = ({ user }: GlobalState): boolean =>
  user.isGainedBottles;
export const selectLoggedUser = ({ user }: GlobalState): UserDb =>
  user.loggedUser.value;
export const selectAuthToken = ({ user }: GlobalState): string =>
  user.loggedUser.token;
export const selectIsShowFeed = ({ user }: GlobalState): boolean =>
  user.isShowFeed;
export const selectViewedStoreis = ({ user }: GlobalState): string[] =>
  user.viewedStories;
export const selectBookmarksNotificationHidden = (
  state: GlobalState
): boolean => {
  if (typeof window === 'undefined') return true;

  // const featureFlags = selectFeatureFlags(state);
  // if (featureFlags.BOOKMARKS_ON) return false;

  return state.user.bookmarksNotificationHidden;

  // return (
  //   state.user.bookmarksNotificationHidden ||
  //   window.outerHeight - window.innerHeight > 90
  // );
};

export const selectBookmarksTooltipShown = ({ user }: GlobalState): boolean =>
  user.showBookmarksTooltip;

export const selectBookmarksDiscovered = ({ user }: GlobalState): boolean =>
  user.bookmarksDiscovered;

export const selectTotalShellsCounter = ({ user }: GlobalState): number =>
  user.shells.shellsCounter;
export const selectBottlesCounter = (state: GlobalState): number =>
  Math.floor(selectTotalShellsCounter(state) / 100);

type StepName =
  | 'counterFirstBottle'
  | 'shellsAlgorithm'
  | 'customizeBg'
  | 'topSites'
  | 'shells'
  | 'counter'
  | 'searchForm'
  | 'banner'
  | 'socialFeed';

export const selectOnboardingStep = (state: GlobalState): StepName => {
  if (state.user.showBookmarksTooltip || selectUiMode(state) === 'focus') {
    return null;
  }

  const { user, friends } = state;
  const { onboarding, ntpVisitCounter } = user;

  if (friends.openedHeaderPopover || (user.isInvited && ntpVisitCounter < 2)) {
    return null;
  }

  const now = Date.now();
  // if (
  //   onboarding.counterFirstBottle &&
  //   Math.floor(user.shells.shellsCounter / 100)
  // ) {
  //   return 'counterFirstBottle';
  // } else if (onboarding.customizeBg && user.shells.shellsCounter >= 20) {
  //   return 'customizeBg';
  // } else 
  if (
    onboarding.shellsAlgorithm &&
    toDayFormat(onboarding.startedAt) !== toDayFormat(now)
  ) {
    return 'shellsAlgorithm';
  } else {
    // const steps: StepName[] = ['shells', 'counter', 'searchForm', 'socialFeed'];
    const steps: StepName[] = ['shells', 'counter', 'searchForm'];
    const nextStep = steps.find((v) => onboarding[v]);

    if (nextStep) return nextStep;

    if (onboarding.topSites && selectAdTiles(state).length && (user.utmCampaign || getDaysOfUsage(user.installationDate) >= 3)) {
      return 'topSites';
    }

    // if (onboarding.customizeBg) return 'customizeBg';

    return null;
  }
};

const DEFAULT_GOOGLE_ACCOUNTS_LIST = [];
export const selectGoogleAccounts = ({ user }: GlobalState): GoogleAccount[] =>
  user.googleAccounts || DEFAULT_GOOGLE_ACCOUNTS_LIST;
